import React, { useEffect } from 'react';
import logo from '../../assets/collaborationlogo.png';
import { Field, Form, FormElement } from "@progress/kendo-react-form";
import { login } from "../../actions/index.js"
import { Input } from "@progress/kendo-react-inputs";
import { getter } from "@progress/kendo-react-common";
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { ssoLogin } from '../../actions/ssoLogin.js';

function Redirect(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [searchParams, setSearchParams] = useSearchParams();

  const mobileFunc = (body) => {
    window.location.assign(body.url);
  }

  const standardFunc = () => {
    navigate('/dashboard');
  }

  const errorFunc = () => {
    navigate('/');
  }

  useEffect(() => {
    dispatch(ssoLogin(searchParams.toString(), mobileFunc, standardFunc, errorFunc))
  }, [searchParams])

  return (
    <div id="values" style={styles.loginContainer}>
    </div>
  );
}

const styles = {
  loginContainer: {
    display: "flex",
    justifyContent: "center",
    height: "100vh",
    alignItems: "center",
    backgroundColor: 'white',
    color: 'white'
  },
  logo: {
    height: "180px",
  },
  formField: {
    marginTop: 20
  },
  loginBtn: {
    marginTop: 10,
    padding: 10,
  },
}

export default Redirect;
